import React from 'react';
import PropTypes from 'prop-types';
import reactStringReplace from 'react-string-replace';

import { useTheme } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import Grid from '@material-ui/core/Grid';

import { COMMUNITY_FORUM } from '../../../utils/constants';
import { useStyles } from './styles';
import Dialog from '../../Dialog';
import Link from '../../Link';
import { useTranslation } from 'react-i18next';

const AboutDialog = ({ open, setOpen, appVersion }) => {
	const { t } = useTranslation();
	const classes = useStyles();
	const theme = useTheme();
	const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));

	const handleClose = () => {
		setOpen(false);
	};

	return (
		<Dialog
			open={open}
			handleClose={handleClose}
			fullScreen={fullScreen}
			fullWidth
			maxWidth={'md'}
			content={
				<Grid container direction="column">
					<Grid item>
						<Typography variant="h5" align="center">
							WebDesigner+&trade; Power Supply
						</Typography>

						<Typography variant="body2" align="center" className={classes.description}>
							WebDesigner+&trade; Power Supply {t('components.navbar.about.description')}
						</Typography>

						<Typography variant="body2" align="center">
							{t('components.navbar.about.details.moreDetails')}
							<Link variant="body2" target="_blank" href={'https://www.onsemi.com/design/webdesigner+'}>
								{t('components.navbar.about.details.linkTitle')} WebDesigner+&trade; Power Supply
							</Link>
						</Typography>

						<Typography variant="body2" align="center" className={classes.support}>
							<Link variant="body2" href={COMMUNITY_FORUM.url}>
								{COMMUNITY_FORUM.label}
							</Link>
						</Typography>

						<Typography variant="caption" align="center" component="p" gutterBottom>
							{'v' + appVersion + ' '}
							{reactStringReplace(
								'\u00A9 Copyright 1999-^year^ Semiconductor Components Industries, LLC',
								'^year^',
								() => new Date().getFullYear()
							)}
						</Typography>
					</Grid>
				</Grid>
			}
		/>
	);
};

AboutDialog.propTypes = {
	open: PropTypes.bool.isRequired,
	setOpen: PropTypes.func.isRequired,
	appVersion: PropTypes.string.isRequired
};

export default AboutDialog;
